angular.module('rjmNg.directives').directive "datepicker", [
  () ->
    restrict: "E"
    template: '
      <div class="input-append date" ng-class="{\'input-prepend\': oldestClicked||newestClicked, \'invalid-date\': valid==false}" data-date="" data-date-format="yyyy-mm-dd">
        <span ng-click="oldestClicked(); $event.stopPropagation()" ng-if="oldestClicked" class="add-on" bs-tooltip data-original-title="Oldest Available Date" data-placement="left"><span class="rj-icon--step-backward"></span></span>
        <span ng-click="newestClicked(); $event.stopPropagation()" ng-if="newestClicked" class="add-on" bs-tooltip data-original-title="Now" data-placement="left"><span class="rj-icon--step-forward"></span></span>
        <input type="text" id="date" value="{{date}}" class="input-medium rj-input--legacy" readonly/>
        <span class="rj-icon--calendar add-on"></span>
      </div>',
    replace: true,
    scope:
      date: "="
      changeFn: "&"
      valid: "="
      oldestClicked: "="
      newestClicked: "="
    link: (scope, element, attrs) ->

      options =
        orientation: "bottom left"
        autoclose: true
        forceParse: false

      element.datepicker(options)

      if scope.date?
        element.datepicker("setValue", scope.date)

      element.datepicker().on('changeDate', (event) ->

        # Make sure changes are made to the model
        scope.$apply ->
          date = _stringifyDate(event.date)

          if attrs.showTime is "true"
            date = date + " 00:00:00"

          scope.date = date
          element.find("#date").val(date)
          scope.changeFn()
      )

      _stringifyDate = (date) ->
        month = _twoDigit(date.getMonth()+1)
        day = _twoDigit(date.getDate())
        return "#{date.getFullYear()}-#{month}-#{day}"

      _twoDigit = (value) ->
        return if value < 10 then "0#{value}" else value

  ]
